import React from "react";
import CustomEditButton from "@/common/components/custom/buttons/CustomEditButton";
import { ButtonWrapper } from "../../../AdminCommandPage.styled";
import { WIZARD_STEP } from "../constants";
import { Hint } from "../AddLanguageWizard.styled";
import TargetLanguageLabel from "./TargetLanguageLabel";

const StepCopyLessons = ({
  targetLanguage,
  setStep,
  handleDuplicateLessons,
}) => (
  <>
    <TargetLanguageLabel language={targetLanguage} />
    <Hint>
      Copies levels, categories and lessons from EN to this language. Wait until
      the job finishes before importing the CSV.
    </Hint>
    <ButtonWrapper>
      <CustomEditButton
        text="Back"
        onClick={() => setStep(WIZARD_STEP.ADD_LANGUAGE)}
      />
      <CustomEditButton
        text="Copy lessons from EN"
        onClick={handleDuplicateLessons}
      />
      <CustomEditButton
        text="Next"
        onClick={() => setStep(WIZARD_STEP.IMPORT_DATABASE)}
      />
    </ButtonWrapper>
  </>
);

export default StepCopyLessons;
